import { Empty } from "antd";
import img from "../images/nodata.png";

const NoData = () => {
  return <Empty
    image={img}
    imageStyle={{
      height: 120,
      marginTop: 40
    }}
    description={"No Data"}
  />
}
export default NoData;